<template>
  <vs-popup class="add-new-company-holiday"
            id="popup"
            title="BOOK IN RM BATCH"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card v-if="!is_have_test_data">
      <vs-alert color="danger" active="false">
        There is no default test data for this raw material
      </vs-alert>
      <vs-button @click.stop="onClickAddDefaultTestData" class="ml-auto mt-4">Add default test data</vs-button>
    </vx-card>
    <vx-card no-shadow v-else>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">

          <vx-card subtitle="QC TEST" :cardBorder="true" no-shadow class="hidden">
            <!-- <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Test Type
                  </small>
                  <v-select :disabled="company_data.test_type || company_data.test_type.length > 0" :clearable="false" name="country" placeholder=""
                            label="name" v-model="form.test_type" :reduce="option => option.value"
                            :options="test_types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="q_c_status" name="q_c_status" rules="" v-slot="{ errors }">
                  <small class="label">Status</small>
                  <v-select :clearable="true" name="q_c_status" placeholder="" v-model="form.q_c_status"
                            :options="['Approved', 'Rejected']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div> -->

            <!--        start  Odour_and_Appearance_Check-->
            <!-- <div class="vx-row mb-3" v-if="form.test_type === 'Odour_and_Appearance_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_check_odour" name="o_a_check_odour" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                  </small>
                  <vs-input v-model="form.o_a_check.odour"  name="o_a_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_check_appearance" name="o_a_check_appearance" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                  </small>
                  <vs-input v-model="form.o_a_check.appearance"  name="o_a_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div> -->
            <!--          end Odour_and_Appearance_Check-->

            <!--          start Taste_Odour_and_Appearance_Check-->
            <!-- <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="t_o_a_check_taste" name="t_o_a_check_taste" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Taste <span v-if="company_data.taste" class="qc-test-guide-text">(Guide: {{ company_data.taste }})</span>
                  </small>
                  <vs-input v-model="form.t_o_a_check.taste"  name="t_o_a_check_taste" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="t_o_a_check_odour" name="t_o_a_check_odour" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                  </small>
                  <vs-input v-model="form.t_o_a_check.odour"  name="t_o_a_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div> -->

            <!-- <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="t_o_a_check_appearance" name="t_o_a_check_appearance" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                  </small>
                  <vs-input v-model="form.t_o_a_check.appearance"  name="t_o_a_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div> -->
            <!--         end Taste_Odour_and_Appearance_Check-->

            <!--          start Odour_Appearance_SG_and_RI_Check-->
            <!-- <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_s_r_check_odour" name="o_a_s_r_check_odour" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.odour"  name="o_a_s_r_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_s_r_check_appearance" name="o_a_s_r_check_appearance" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.appearance"  name="o_a_s_r_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div> -->

            <!-- <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="s_g" name="s_g" rules="required" v-slot="{ errors }">
                  <small class="label">
                    SG  <span v-if="company_data.sg_from && company_data.sg_to" class="qc-test-guide-text">(Guide: {{ company_data.sg_from }} - {{ company_data.sg_to }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.s_g"  name="s_g" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="r_i" name="r_i" rules="required" v-slot="{ errors }">
                  <small class="label">
                    RI <span v-if="company_data.ri_from && company_data.ri_to" class="qc-test-guide-text">(Guide: {{ company_data.ri_from }} - {{ company_data.ri_to }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.r_i"  name="r_i" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div> -->

            <!--          end Odour_Appearance_SG_and_RI_Check-->

            <div class="vx-row mb-3" v-if="form.q_c_status === 'Rejected'">
              <div class="vx-col w-1/2">
                <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                  <small class="label">Quantity Available (KG)</small>
                  <vs-input disabled v-model="rm_item.quantity_pending_to_receive"   name="quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col w-1/2">
                <ValidationProvider vid="notes" name="notes" :rules="`required|min_qty:${rm_item.quantity_pending_to_receive}`" v-slot="{ errors }">
                  <small class="label">Quantity in this batch (KG)</small>
                  <vs-input type="number" step="0.0001" v-model="stock_form.quantity"   name="quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="invoice_number" name="invoice_number" rules="" v-slot="{ errors }">
                  <small class="label">Invoice Number</small>
                  <vs-input v-model="form.invoice_number" name="invoice_number" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="batch_note" name="batch_note" rules="" v-slot="{ errors }">
                  <small class="label">RM Batch Notes</small>
                  <vs-textarea class="mb-0" v-model="form.batch_note" height="70px"/>
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                  <small class="label">QC Notes</small>
                  <vs-textarea class="mb-0" v-model="form.notes" height="70px"/>
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
          <vx-card v-if="form.q_c_status !== 'Rejected'" class="mt-8"  subtitle="RM STOCK INVENTORY" :cardBorder="true" no-shadow>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="quantity" name="quantity" rules="" v-slot="{ errors }">
                  <small class="label">Quantity Available (KG)</small>
                  <vs-input disabled v-model="rm_item.quantity_pending_to_receive"   name="quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="quantity" name="quantity" :rules="`required|min_qty:${rm_item.quantity_pending_to_receive}`" v-slot="{ errors }">
                  <small class="label">Quantity in this batch (KG)</small>
                  <vs-input type="number" step="0.0001" v-model="stock_form.quantity"   name="quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  <small class="text-warning">*You must run a QC test for each date batch in this order</small>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="supplier_batch_no" name="supplier_batch_no" :rules="`required`" v-slot="{ errors }">
                  <small class="label">Supplier batch no</small>
                  <vs-input v-model="stock_form.supplier_batch_no"   name="supplier_batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="manufacture_date" name="manufacture_date" rules="required" v-slot="{ errors }">
                  <small class="label">Manufacturing Date</small>
                  <flat-pickr
                    :config="{dateFormat: 'd/m/Y', maxDate: 'today'}"
                    class="hidden"
                    v-model="stock_form.manufacture_date"
                    placeholder="Choose Manufacture Date"/>

                  <flat-pickr :config="{dateFormat: 'd/m/Y', maxDate: 'today'}" class="w-full" v-model="stock_form.manufacture_date"
                              placeholder="Choose Manufacture Date"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="expiration_date" name="expiration_date" rules="required" v-slot="{ errors }">
                  <small class="label">ITS Expiry Date</small>
                  <flat-pickr
                    :config="{dateFormat: 'd/m/Y', minDate: 'today'}"
                    class="hidden"
                    v-model="stock_form.expiration_date"
                    placeholder="Choose Expiration Date"/>

                  <flat-pickr :config="{dateFormat: 'd/m/Y', minDate: 'today'}" class="w-full" v-model="stock_form.expiration_date"
                              placeholder="Choose Expiration Date"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
<!--            <div class="vx-row mb-3">-->
<!--              <div class="vx-col md:w-1/3 w-full md:mb-0">-->
<!--                <ValidationProvider vid="shelf_location_r" name="shelf_location_r" rules="" v-slot="{ errors }">-->
<!--                  <vx-input-group>-->
<!--                    <template slot="prepend">-->
<!--                      <div class="prepend-text bg-primary">-->
<!--                        <span>R</span>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <v-select v-model="stock_form.shelf_location_r" style="border-radius: 0; z-index: 9" :options="shelf_location_r_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
<!--                  </vx-input-group>-->
<!--                  <small class="text-danger">{{errors[0]}}</small>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--              <div class="vx-col md:w-1/3 w-full md:mb-0">-->
<!--                <ValidationProvider vid="shelf_location_s" name="shelf_location_s" rules="" v-slot="{ errors }">-->
<!--                  <vx-input-group>-->
<!--                    <template slot="prepend">-->
<!--                      <div class="prepend-text bg-primary">-->
<!--                        <span>S</span>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <v-select v-model="stock_form.shelf_location_s" style="border-radius: 0; z-index: 9" :options="shelf_location_s_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->

<!--                  </vx-input-group>-->
<!--                  <small class="text-danger">{{errors[0]}}</small>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--              <div class="vx-col md:w-1/3 w-full md:mb-0">-->
<!--                <ValidationProvider vid="shelf_location_l" name="shelf_location_l" rules="" v-slot="{ errors }">-->
<!--                  <vx-input-group>-->
<!--                    <template slot="prepend">-->
<!--                      <div class="prepend-text bg-primary">-->
<!--                        <span>L</span>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <v-select v-model="stock_form.shelf_location_l" style="border-radius: 0; z-index: 9" :options="shelf_location_l_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
<!--                  </vx-input-group>-->
<!--                  <small class="text-danger">{{errors[0]}}</small>-->
<!--                </ValidationProvider>-->
<!--              </div>-->
<!--            </div>-->

          </vx-card>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="is_submit" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const InventoryRepository = RepositoryFactory.get('inventory');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const SettingsRepository = RepositoryFactory.get('settings');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import {mapActions, mapGetters} from "vuex";

  function initialState() {
    return {
      open: false,
      id: '',
      is_have_test_data: true,
      stock_form: {
        manufacture_date: '',
        expiration_date: '',
        batch_no: '',
        company_product_code: '',
        category: '',
        quantity: '',
        supplier_batch_no: '',
      },
      shelf_location_r_options: [],
      shelf_location_s_options: [],
      shelf_location_l_options: [],
      form: {
        test_type:'',
        o_a_check: {
          odour: '',
          appearance: ''
        },
        t_o_a_check: {
          taste: '',
          odour: '',
          appearance: ''
        },
        o_a_s_r_check: {
          odour: '',
          appearance: '',
          s_g: '',
          r_i: '',
        },
        notes: '',
        q_c_status: '',
        quantity: '',
        invoice_number: '',
        batch_note: ''
      },
      isCreateMode: true,
      test_types: [
        {name: 'Do Not Sample', value: 'Do_Not_Sample'},
        {name: 'Odour and Appearance Check', value: 'Odour_and_Appearance_Check'},
        {name: 'Taste Odour and Appearance Check', value: 'Taste_Odour_and_Appearance_Check'},
        {name: 'Odour Appearance SG and RI Check', value: 'Odour_Appearance_SG_and_RI_Check'}
      ],
      raw_material_id: null,
      company_data: {},
      rm_item: {},
      is_submit: false
    }
  }

  export default {
    name: 'AddQcTestRmOrderItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(rm_item) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          this.id = rm_item.id
          this.rm_item = rm_item
          // this.stock_form.quantity = rm_item.quantity_pending_to_receive
          this.raw_material_id = rm_item.raw_material_id
          await this.fetchRmCompanyData()
          // await this.generateShelfLocationOptions()
        } catch (error) {

        }
      },
      async fetchRmCompanyData() {
        this.$vs.loading();
        try {
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialCompanyData(this.raw_material_id)).data
          this.company_data = data
          this.form.test_type = this.company_data.test_type
        } catch (e) {
          this.is_have_test_data = false
        }
        this.$vs.loading.close()
      },
      async generateShelfLocationOptions() {

        const settings = (await SettingsRepository.getTheItem('shelf_location_r_from,shelf_location_r_to,shelf_location_s_from,shelf_location_s_to,shelf_location_l_from,shelf_location_l_to')).data.data

        let r_from = settings.shelf_location_r_from
        let r_to = settings.shelf_location_r_to

        let s_from = settings.shelf_location_s_from
        let s_to = settings.shelf_location_s_to

        let l_from = settings.shelf_location_l_from
        let l_to = settings.shelf_location_l_to

        let start_r = Number(r_from)
        const end_r = Number(r_to)

        let start_s = Number(s_from)
        const end_s = Number(s_to)

        let start_l = Number(l_from)
        const end_l = Number(l_to)

        while (start_r <= end_r) {
          this.shelf_location_r_options.push(start_r.toString());
          start_r++;
        }

        while (start_s <= end_s) {
          this.shelf_location_s_options.push(start_s.toString());
          start_s++;
        }

        while (start_l <= end_l) {
          this.shelf_location_l_options.push(start_l.toString());
          start_l++;
        }

      },
      onClickAddDefaultTestData() {
        this.open = false
        this.$router.push(`/pages/raw-materials/${this.raw_material_id}?step=23`)
      },
      async onClickCreateQcTest() {
        // this.$vs.loading();
        const vue = this;
         this.onClickAssign()
        // try {
        //   this.form.staff_raw_material_order_item_id = this.id
        //   this.form.quantity = this.stock_form.quantity
        //   let { data } = (await InventoryRepository.createOrderItemQcTest(this.form)).data
        //   this.showSuccessMessage('Item QC Test added!');
        //   if(this.form.q_c_status === 'Approved') {
           
        //   } else {
        //     this.open = false
        //     await vue.$parent.refreshData();
        //   }
        // } catch (e) {
        //   this.$vs.loading.close();
        //   this.convertAndNotifyError(e)
        // }
        // this.$vs.loading.close()
      },
      async onClickAssign(qc_id = null) {
        this.is_submit = true
        const vue = this
        try {
          const payload = {
            staff_raw_material_order_item_id: this.rm_item.id,
            supplier_raw_material_id: this.rm_item.raw_material_id,
            quantity: this.stock_form.quantity,
            supplier_batch_no: this.stock_form.supplier_batch_no,
            shelf_location_r: this.stock_form.shelf_location_r,
            shelf_location_s: this.stock_form.shelf_location_s,
            shelf_location_l: this.stock_form.shelf_location_l,
            manufacture_date: this.stock_form.manufacture_date,
            expiration_date: this.stock_form.expiration_date,
            // staff_r_m_item_q_c_test_id: qc_id
          }
          await ManufacturingRepository.createRawMaterialStock(payload)
          this.showSuccessMessage('Raw Material Stock Inventory created!')
          this.open = false
          await vue.$parent.refreshData();
        } catch (e) {
          this.convertAndNotifyError(e)
        } finally {
          this.is_submit = false
        }

      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
  .qc-test-guide-text {
    color: coral;
    font-weight: bold ;
    margin-left: 5px;
  }

</style>
